import React, {Component} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'

import { Alert, AlertTitle, Collapse, Paper, Snackbar } from '@mui/material'

const {DateTime} = require('luxon')
const RestTunel = require('../../libs/rest_tunnel')

const money = (v) => '$' + Number(v || 0).toLocaleString('es-CO', { maximumFractionDigits: 0 })
const num = (v) => Number(v || 0).toLocaleString('es-CO')

class DenominacionesFamiliaPage extends Component {
  constructor() {
    super()
    var fechaFinTemp = DateTime.local().set({hour: 23, minute: 59, second: 59})

    this.state = {
      grupos: [],
      cajeros: [],
      entidades: [],
      registros: [],
      filtroFechaInicio: null,
      filtroFechaFin: fechaFinTemp,
      mostrarAlerta: false,
      mensajeAlerta: '',
      severidadAlerta: 'info'
    }

    this.btnBuscarClick = this.btnBuscarClick.bind(this)
    this.exportExcel = this.exportExcel.bind(this)

    this.cmbGrupos = React.createRef()
    this.cmbCajeros = React.createRef()
    this.cmbEntidades = React.createRef()

    this.filtroFechaInicio = ""
    this.filtroFechaFin = ""
  }

  btnBuscarClick() { this.queryReporte() }

  handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') return
    this.setState({ mostrarAlerta: false })
  }

  fechaFiltroChanged(origen, date) {
    if (date == null) return
    var formatoFechaInicio = "yyyy-LL-dd 00:00:00"
    var formatoFechaFin = "yyyy-LL-dd 23:59:59"
    switch (origen) {
      case 'inicio':
        this.setState({ filtroFechaInicio: date })
        this.filtroFechaInicio = date.toFormat(formatoFechaInicio)
        break
      case 'fin':
        this.setState({ filtroFechaFin: date })
        this.filtroFechaFin = date.toFormat(formatoFechaFin)
        break
      default:
    }
  }

  queryGrupos() {
    var restArgs = { method: 'POST', headers: 'JSON', body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/usuarios/grupos/list' }
    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) this.setState({ grupos: [], mostrarAlerta: true, mensajeAlerta: 'Error consultando grupos', severidadAlerta: 'error' })
      else this.setState({ grupos: data })
    })
  }

  queryEntidades() {
    var restArgs = { method: 'POST', headers: 'JSON', body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/entidades/usuario/list' }
    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) this.setState({ entidades: [], mostrarAlerta: true, mensajeAlerta: 'Error consultando entidades', severidadAlerta: 'error' })
      else this.setState({ entidades: data })
    })
  }

  queryCajeros() {
    var restArgs = { method: 'POST', headers: 'JSON', body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/usuarios/cajerosconsultas/list' }
    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) this.setState({ cajeros: [], mostrarAlerta: true, mensajeAlerta: 'Error consultando cajeros', severidadAlerta: 'error' })
      else this.setState({ cajeros: data })
    })
  }

  queryReporte() {
    var filtroIdGrupo = ''
    var filtroIdCajero = ''
    var filtroIdEntidad = ''

    if (this.cmbGrupos.current.value !== 0) filtroIdGrupo = this.cmbGrupos.current.value
    if (this.cmbCajeros.current.value !== 0) filtroIdCajero = this.cmbCajeros.current.value
    if (this.cmbEntidades.current.value !== 0) filtroIdEntidad = this.cmbEntidades.current.value

    if (filtroIdGrupo === '' && filtroIdCajero === '') {
      this.setState({ mostrarAlerta: true, mensajeAlerta: 'Debe seleccionar un grupo o un cajero', severidadAlerta: 'warning' })
      return
    }

    var restArgs = {
      method: 'POST', headers: 'JSON',
      body: {
        filtro_id_grupo: filtroIdGrupo,
        filtro_id_cajero: filtroIdCajero,
        filtro_id_entidad: filtroIdEntidad,
        filtro_fecha_inicio: this.filtroFechaInicio,
        filtro_fecha_fin: this.filtroFechaFin
      },
      url: process.env.REACT_APP_URL_BACKEND + '/reportes/denominacionesfamilia/'
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) this.setState({ registros: [], mostrarAlerta: true, mensajeAlerta: 'Error consultando el reporte', severidadAlerta: 'error' })
      else this.setState({ registros: Array.isArray(data) ? data : [] })
    })
  }

  // Fila de totales sumando todas las denominaciones.
  calcularTotales() {
    return (this.state.registros || []).reduce((t, r) => ({
      vieja_cant: t.vieja_cant + Number(r.vieja_cant || 0),
      vieja_valor: t.vieja_valor + Number(r.vieja_valor || 0),
      nueva_cant: t.nueva_cant + Number(r.nueva_cant || 0),
      nueva_valor: t.nueva_valor + Number(r.nueva_valor || 0),
      total_cant: t.total_cant + Number(r.total_cant || 0),
      total_valor: t.total_valor + Number(r.total_valor || 0)
    }), { vieja_cant: 0, vieja_valor: 0, nueva_cant: 0, nueva_valor: 0, total_cant: 0, total_valor: 0 })
  }

  exportExcel() {
    var workbook = new ExcelJS.Workbook()
    var sheet = workbook.addWorksheet("Denominaciones_familia")
    sheet.columns = [
      { header: 'Denominación' },
      { header: 'Familia Vieja (cant)' },
      { header: 'Familia Vieja ($)' },
      { header: 'Familia Nueva (cant)' },
      { header: 'Familia Nueva ($)' },
      { header: 'Total (cant)' },
      { header: 'Total ($)' }
    ]
    this.state.registros.forEach((r) => {
      sheet.addRow([ r.denominacion, r.vieja_cant, r.vieja_valor, r.nueva_cant, r.nueva_valor, r.total_cant, r.total_valor ])
    })
    const t = this.calcularTotales()
    sheet.addRow([ 'TOTAL', t.vieja_cant, t.vieja_valor, t.nueva_cant, t.nueva_valor, t.total_cant, t.total_valor ])

    workbook.xlsx.writeBuffer().then((data) => {
      FileSaver.saveAs(new Blob([data]), 'Denominaciones_familia.xlsx')
      this.setState({ mostrarAlerta: true, mensajeAlerta: 'Archivo generado', severidadAlerta: 'success' })
    })
  }

  componentDidMount() {
    this.queryGrupos()
    this.queryCajeros()
    this.queryEntidades()
  }

  render() {
    const { mostrarAlerta, mensajeAlerta, severidadAlerta } = this.state
    const registros = this.state.registros || []
    const t = this.calcularTotales()
    return (
      <Box>
        <Typography gutterBottom variant="h5" component="div" sx={{ marginBottom: 2 }}>
          Denominaciones por familia
        </Typography>

        <Paper elevation={16}>
          <Card sx={{ p: 2 }}>
            <CardContent>
              <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Grid item container xs={12}>
                  <Typography gutterBottom variant="h6" component="div">Filtrar:</Typography>
                  <Grid item container spacing={2}>
                    <Grid item xs={2}>
                      <LocalizationProvider dateAdapter={AdapterLuxon}>
                        <DatePicker inputFormat="dd/MM/yyyy" label="Fecha inicio"
                          value={this.state.filtroFechaInicio}
                          onChange={date => this.fechaFiltroChanged('inicio', date)}
                          renderInput={(params) => <TextField {...params} />} />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={2}>
                      <LocalizationProvider dateAdapter={AdapterLuxon}>
                        <DatePicker inputFormat="dd/MM/yyyy" label="Fecha fin"
                          value={this.state.filtroFechaFin}
                          onChange={date => this.fechaFiltroChanged('fin', date)}
                          renderInput={(params) => <TextField {...params} />} />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={2}>
                      <FormControl fullWidth>
                        <InputLabel>Grupo</InputLabel>
                        <Select label="Grupo" inputRef={this.cmbGrupos} defaultValue={0}>
                          <MenuItem value={0}>--Seleccione--</MenuItem>
                          {this.state.grupos.map(grupo => (<MenuItem key={grupo.id} value={grupo.id}>{grupo.nombre}</MenuItem>))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={2}>
                      <FormControl fullWidth>
                        <InputLabel>Cajero</InputLabel>
                        <Select label="Cajero" inputRef={this.cmbCajeros} defaultValue={0}>
                          <MenuItem value={0}>-- Seleccione --</MenuItem>
                          {this.state.cajeros.map(cajero => (<MenuItem key={cajero.id} value={cajero.id}>{cajero.alias}</MenuItem>))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <InputLabel>Entidad</InputLabel>
                        <Select label="Entidad" inputRef={this.cmbEntidades} defaultValue={0}>
                          <MenuItem value={0}>--Todas--</MenuItem>
                          {this.state.entidades.map(entidad => (<MenuItem key={entidad.id} value={entidad.id}>{entidad.nombre}</MenuItem>))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={2}>
                      <CardActions>
                        <Button size="large" variant="contained" onClick={this.btnBuscarClick}>Buscar</Button>
                        <Snackbar open={mostrarAlerta} onClose={this.handleCloseAlert} autoHideDuration={3000}
                          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                          <Collapse in={mostrarAlerta}>
                            <Alert severity={severidadAlerta} onClose={this.handleCloseAlert} sx={{ marginTop: 4, width: '100%' }}>
                              <AlertTitle>{severidadAlerta.toUpperCase()}</AlertTitle>
                              {mensajeAlerta}
                            </Alert>
                          </Collapse>
                        </Snackbar>
                      </CardActions>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Paper>
        <br />

        <Paper elevation={16}>
          <Card sx={{ p: 2 }}>
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">Denominaciones por familia:</Typography>
              <Divider style={{ marginTop: 10, marginBottom: 10 }} />
              {registros.length > 0 &&
                <Button style={{ marginTop: 10, marginBottom: 10 }} variant='contained' onClick={this.exportExcel}>Exportar</Button>}
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell><b>Denominación</b></TableCell>
                      <TableCell align="right"><b>Familia Vieja (cant)</b></TableCell>
                      <TableCell align="right"><b>Familia Vieja ($)</b></TableCell>
                      <TableCell align="right"><b>Familia Nueva (cant)</b></TableCell>
                      <TableCell align="right"><b>Familia Nueva ($)</b></TableCell>
                      <TableCell align="right"><b>Total (cant)</b></TableCell>
                      <TableCell align="right"><b>Total ($)</b></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {registros.map((r) => (
                      <TableRow key={r.denominacion}>
                        <TableCell>{money(r.denominacion)}</TableCell>
                        <TableCell align="right">{num(r.vieja_cant)}</TableCell>
                        <TableCell align="right">{money(r.vieja_valor)}</TableCell>
                        <TableCell align="right">{num(r.nueva_cant)}</TableCell>
                        <TableCell align="right">{money(r.nueva_valor)}</TableCell>
                        <TableCell align="right">{num(r.total_cant)}</TableCell>
                        <TableCell align="right">{money(r.total_valor)}</TableCell>
                      </TableRow>
                    ))}
                    {registros.length > 0 &&
                      <TableRow>
                        <TableCell><b>TOTAL</b></TableCell>
                        <TableCell align="right"><b>{num(t.vieja_cant)}</b></TableCell>
                        <TableCell align="right"><b>{money(t.vieja_valor)}</b></TableCell>
                        <TableCell align="right"><b>{num(t.nueva_cant)}</b></TableCell>
                        <TableCell align="right"><b>{money(t.nueva_valor)}</b></TableCell>
                        <TableCell align="right"><b>{num(t.total_cant)}</b></TableCell>
                        <TableCell align="right"><b>{money(t.total_valor)}</b></TableCell>
                      </TableRow>}
                    {registros.length === 0 &&
                      <TableRow><TableCell colSpan={7} align="center">Sin datos. Filtra y presiona Buscar.</TableCell></TableRow>}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Paper>
      </Box>
    )
  }
}

export default DenominacionesFamiliaPage
